import DefaultLayout from "@routes/Section/layouts/DefaultLayout/DefaultLayout";
import ThrivePage from "@routes/Section/layouts/Thrive/ThrivePage";
import VerticalsLatestPageContent from "@routes/Section/layouts/Verticals/VerticalsLatestPageContent";
import VerticalsPageContent from "@routes/Section/layouts/Verticals/VerticalsPageContent";
import { SectionPageData } from "@routes/Section/utils/types";

/** The content of the section page. Separated by template. */
const SectionPageContent = (data: SectionPageData): React.ReactElement => {
  switch (data.template) {
    case "verticals":
      return <VerticalsPageContent {...data} />;

    case "verticalsLatest":
      return <VerticalsLatestPageContent {...data} />;

    case "thrive":
      return <ThrivePage {...data} />;

    case "default":
    default:
      return <DefaultLayout {...data} />;
  }
};

export default SectionPageContent;
